import styled from 'styled-components';

export const Menu = styled.div`
  margin: 0;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid light-dark(#ced4da, var(--mantine-color-dark-4));
  background: light-dark(var(--mantine-color-body), var(--mantine-color-dark-6));
  margin-right: 50px;
  box-shadow:
    0px 1px 2px 0px light-dark(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.4)),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05),
    0 8px 24px light-dark(transparent, rgba(0, 0, 0, 0.45));
`;

export const Item = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  cursor: pointer;
  border-radius: 4px;
  width: 186px;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */

  &.danger {
    color: light-dark(#e03131, var(--mantine-color-red-4));
  }

  &:hover {
    background: light-dark(#f1f3f5, var(--mantine-color-dark-5));
  }
`;
